import { render, staticRenderFns } from "./activity-logs.vue?vue&type=template&id=745e523c"
import script from "./activity-logs.vue?vue&type=script&lang=js"
export * from "./activity-logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports